<template>
    <div>
      <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
      </base-header>
      <div class="container-fluid mt--8">
        <div class="card shadow">
          <div class="row p-3">
            <div class="col-lg-8 col-8 mb-1">
              <button
                v-on:click="onEditRow"
                :disabled="!showActionEdit"
                class="btn btn-primary ml-2"
              >
                <i class="fa fa-edit"></i> Details
              </button>
              <download-excel
                :data="selectedItems"
                name="EmsSchedulerProcess-selected-report.csv"
                type="csv"
                style="float: left"
              >
                <button class="btn btn-primary ml-2">
                  <i class="fa fa-download"></i>
                  Export selected
                </button>
              </download-excel>
              <button v-on:click="onCreateSchedulerReProcess" class="btn btn-primary">
                Create
              </button>
            </div>
          </div>
          <div v-if="message">
            <base-alert :type="message.type" :dismissible="true">{{
              message.message
            }}</base-alert>
          </div>
          <div v-if="deleteMessages">
            <base-alert
              :type="message.type"
              :dismissible="true"
              v-for="(row, index) in deleteMessages"
              :key="index"
              >{{ row.message }}</base-alert
            >
          </div>
          <div class="accordion p-3" role="tablist">
            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button
                  block
                  v-b-toggle.accordion-1
                  variant="neutral"
                  class="text-left"
                  >Search Transaction Criteria
                  <span class="when-opened ml-3">
                    <i class="fa fa-arrow-down" />
                  </span>
                  <span class="when-closed ml-3">
                    <i class="fa fa-arrow-right" />
                  </span>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-1"
                visible
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <div class="mb-3 row">
                    <label class="col-sm-2 col-form-label form-control-label">
                      Brand
                    </label>
                    <div class="col-sm-2">
                      <b-form-select
                        id="input-3"
                        v-model="BrandCodeModel"
                        :options="brandCodeOption"
                        class="mx-input"
                        required
                      ></b-form-select>
                    </div>
                  </div>
                  <div class="mt-3 row">
                    <div class="col-sm-2 col-form-label form-control-label"></div>
                    <button
                      v-on:click="onSearchFilter"
                      class="btn btn-warning ml-3"
                    >
                      <i class="fa fa-search"></i> Search
                    </button>
                    <button
                      v-on:click="onSearchExport"
                      class="btn btn-warning ml-2"
                    >
                      <i class="fa fa-download"></i> Search and Export
                    </button>
                    <button
                      v-on:click="onResetFilter"
                      class="btn btn-neutral ml-2"
                    >
                      <i class="fa fa-times"></i> reset query
                    </button>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
          <vue-bootstrap4-table
            :rows="rows"
            :columns="columns"
            :config="config"
            :classes="classes"
            @on-select-row="onSelectRow"
            @on-unselect-row="onSelectRow"
            @on-all-select-rows="onSelectAllRow"
          >
          </vue-bootstrap4-table>
          <div class="overflow-auto mt-3">
            <nav>
              <ul class="pagination b-pagination justify-content-center">
                <li class="col-12 p-0 pl-2">
                  <label class="ml-2">Go to page: </label>
                  <b-form-select
                    size="sm"
                    class="col-1 ml-2 mr-2"
                    v-model="currentPage"
                    :options="arrayPages()"
                    required
                  ></b-form-select>
                  <b-button
                    v-if="currentPage != 1"
                    v-on:click="onLoadData(currentPage - 1)"
                    class="ml-3 mr-1 btn-sm btn-neutral"
                  >
                    <i class="fa fa-less-than"></i>
                  </b-button>
                  <b-button
                    v-if="currentPage != totalPages"
                    v-on:click="onLoadData(currentPage + 1)"
                    class="ml-1 mr-3 btn-sm btn-neutral"
                  >
                    <i class="fa fa-greater-than"></i>
                  </b-button>
  
                  <label class="ml-2">Show rows: </label>
                  <b-form-select
                    size="sm"
                    class="col-1 ml-2 mr-2"
                    v-model="itemPerPage"
                    :options="ItemPerPageList"
                    required
                  ></b-form-select>
                  <label
                    >{{ itemPerPage * currentPage - itemPerPage + 1 }} -
                    {{
                      currentPage == totalPages
                        ? totalItems
                        : itemPerPage * currentPage
                    }}
                    of {{ totalItems }}
                  </label>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
      <modal :show.sync="showModalDetails" modal-classes="modal-md">
        <h3 slot="header" class="modal-title" id="modal-title-default">
          {{ this.titlePopup }} Block User API Report
        </h3>
        <table class="table table-striped">
          <tr>
            <td>Brand</td>
            <td>{{ this.SchedulerReProcessModel.brand_code }}</td>
          </tr>
          <tr>
            <td>Start Date</td>
            <td>{{ this.SchedulerReProcessModel.start_date }}</td>
          </tr>
          <tr>
            <td>End Date</td>
            <td>{{ this.SchedulerReProcessModel.end_date }}</td>
          </tr>
          <tr>
            <td>ReProcess</td>
            <td>{{ this.SchedulerReProcessModel.reprocess }}</td>
          </tr>
          <tr>
            <td>Process Category</td>
            <td>{{ this.SchedulerReProcessModel.process_category }}</td>
          </tr>
          <tr>
            <td>Sub Process Category</td>
            <td>{{ this.SchedulerReProcessModel.sub_process_category }}</td>
          </tr>
          <tr>
            <td>Is Complete Process</td>
            <td>{{ this.SchedulerReProcessModel.is_process_complete }}</td>
          </tr>
          <tr>
            <td>Create Date</td>
            <td>{{ this.SchedulerReProcessModel.created_date_utc }}</td>
          </tr>
          <tr>
            <td>Modify Date</td>
            <td>{{ this.SchedulerReProcessModel.modified_date_utc }}</td>
          </tr>
          <tr></tr>
        </table>
      </modal>
  
      <modal :show.sync="showModalCreate" modal-classes="modal-lg">
        <h3 slot="header" class="modal-title" id="modal-title-default">
          {{ this.titlePopup }} Scheduler Process Config
        </h3>
        <div v-if="messageCreate">
            <base-alert :type="messageCreate.type" :dismissible="true">{{
              messageCreate.message
            }}</base-alert>
          </div>
        <form @submit.prevent>
          <div class="row">
            <div class="col-lg-6">
              <div class="form-group has-label">
                <label class="form-control-label">
                  Brand Code
                </label>
                <model-list-select
                  :list="brandCodeOption"
                  v-model="BrandCodeModel"
                  option-value="value"
                  option-text="text"
                  placeholder="select item"
                  :isDisabled="isBrandCodeDisabled"
                >
                </model-list-select>
              </div>
            </div>
  
          </div>
          <div class="row">
            <div class="col-lg-12">
              <div class="form-group has-label">
                <label class="form-control-label"> Start End Date </label>
                <date-picker
                  v-model="startEndDate"
                  range
                  editable
                  clearable
                  value-type="YYYY-MM-DD"
                  id="StartEndDate"
                  :default-value="startEndDate"
                  style="width: 100%"
                ></date-picker>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <label class="form-control-label"> Process Category</label>
              <model-list-select
                :list="ProcessCategoryOptionCreate"
                v-model="ProcessCategoryModel"
                option-value="value"
                option-text="text"
                placeholder="Select Process Category"
                :isDisabled="isProcessCategoryDisabled"
              >
              </model-list-select>      
            </div>
          </div>
          <div class="row" v-if="ProcessCategoryModel === 'CCDashboard'">
            <div class="col-lg-6">
              <label class="form-control-label">Sub Process Category</label>
              <model-list-select
                :list="SubProcessCategoryOptionCreate"
                v-model="SubProcessCategoryModel"
                option-value="value"
                option-text="text"
                placeholder="Select Sub Process Category"
                :isDisabled="isSubProcessCategoryDisabled"
              >
              </model-list-select>      
            </div>
          </div>
          <br>
        </form>
        <template slot="footer">
          <base-button
            type="link"
            class="ml-auto"
            @click="showModalCreate = false"
            >Close/ Cancel
          </base-button>
          <button
            v-on:click="createSchedulerReProcess"
            class="btn btn-primary"
            v-bind:disabled="disableButtonSubmit"
          >
            Submit
          </button>
        </template>
      </modal>
    </div>
  </template>
  <script>
  import VueBootstrap4Table from "vue-bootstrap4-table";
  import { ModelListSelect } from "vue-search-select";
  import "vue-search-select/dist/VueSearchSelect.css";
  import { API } from "aws-amplify";
  import * as queries from "../graphql/queries";
  import "vue2-datepicker/index.css";
  import api_loyalty from "../api/api";
  import NProgress from "nprogress";
  import axios from "axios";
  
  export default {
    name: "configList",
    data() {
      return {
        SummaryData: [],
        totalItems: 0,
        totalPages: 0,
        isCompletedLoadAllItems: false,
        nextToken: null,
        ListNextToken: [],
        itemPerPage: 50,
        ItemPerPageList: [50, 100, 500, 1000, 5000],
        currentPage: 1,
        IsConditionFilterDisabled: true,
        BrandCodeModel: "PHFortune",
        ChartBrandCodeModel: "PHFortune",
        DateRangeModel: null,
        ValueFilterModel: "",
        PropertyFilterModel: "",
        ConditionFilterModel: "is",
        IsProcessCompleteModel: "",
        ReProcessModel: "",
        ProcessCategoryModel: "",
        startEndDate: [],
        isSubProcessCategoryDisabled : false,
        isProcessCategoryDisabled :false,
        SubProcessCategoryModel:"",
        PropertyFilterList: [
          { text: "Is Process Complete", value: "is_process_complete" },
        ],
        showLoadButton: true,
        timeFilter: [],
        filter: {
          brand_code: "",
        },
        allTransaction: [],
        deleteMessages: [],
        showConfirmationModal: false,
        selectedItems: [],
        showActionEdit: false,
        showActionDelete: false,
        brandCodeOption: [],
        isBrandCodeDisabled: false,
        IsProcessCompleteOption: [
          { text: "All", value: "" },
          { text: "True", value: "1" },
          { text: "False", value: "0" },
        ],
        ProcessCategoryOptionCreate: [
          { text: "Choose Process Category", value: "" },
          { text: "CCDashboard", value: "CCDashboard" },
          { text: "GiftAway", value: "GiftAway" },
          { text: "GIIDStatusSync", value: "GIIDStatusSync" },
          { text: "RaffleWinnerSpecial", value: "RaffleWinnerSpecial" },
          { text: "PendingPrizeGIIDVerified", value: "PendingPrizeGIIDVerified" }
        ],
        SubProcessCategoryOptionCreate: [
          { text: "Choose Sub Process Category", value: "" },
          { text: "BrandRegistration", value: "BrandRegistration" },
          { text: "AccessLog", value: "AccessLog" },
          { text: "TaskLog", value: "TaskLog" },
          { text: "UPCInput", value: "UPCInput" },
          { text: "Redemption", value: "Redemption" },
        ],
        ReProcessOption: [
          { text: "All", value: "" },
          { text: "True", value: 1 },
          { text: "False", value: 0 },
        ],
        titlePopup: "Create",
        message: null,
        messageCreate: null,
        SchedulerReProcessModel: {
          id: "",
          brand_code: "",
          start_date: "",
          end_date: "",
          reprocess: "",
          process_category: "",
          sub_process_category: "",
          is_process_complete:"",
          created_date_utc: new Date().toISOString(),
          modified_date_utc: new Date().toISOString(),
        },
        showModalDetails: false,
        showModalDetail: false,
        showModalCreate: false,
        allMerchants: [],
        rows: [],
        columns: [
          {
            label: "Brand Code",
            name: "brand_code",
            sort: true,
            row_text_alignment: "text-left",
          },
          {
            label: "Process Category",
            name: "process_category",
            sort: true,
          },
          {
            label: "Sub Process Category",
            name: "sub_process_category",
            sort: true,
          },
          {
            label: "Is Process Complete",
            name: "is_process_complete",
            sort: true,
          },
          {
            label: "Create Date",
            name: "created_date_utc",
            sort: true,
            formatter: (value) => {
            const date = new Date(value);
            return date.toISOString().split('T')[0]; 
    },
          },
        ],
        config: {
          pagination: false,
          pagination_info: false,
          num_of_visibile_pagination_buttons: 8,
          per_page: this.itemPerPage ? this.itemPerPage : 50,
          checkbox_rows: true,
          highlight_row_hover: true,
          rows_selectable: true,
          multi_column_sort: true,
          card_mode: false,
          selected_rows_info: true,
          global_search: {
            visibility: true,
          },
          show_refresh_button: false,
          show_reset_button: false,
        },
        classes: {
          table: "table-striped table-bordered",
          row: {
            "my-row my-row2": true,
            "function-class": function (row) {
              return row.id == 1;
            },
          },
        },
      };
    },
    created() {
      this.mappingRole();
      this.onLoadData();
      this.selectedItems.push(this.SchedulerReProcessModel);
    },
    methods: {
      async createSchedulerReProcess() {
        this.SchedulerReProcessModel.brand_code = this.BrandCodeModel;
        if (this.startEndDate.length > 1) {
          this.SchedulerReProcessModel.start_date = new Date(
            this.startEndDate[0]
          ).toISOString();
          this.SchedulerReProcessModel.end_date = new Date(
            this.startEndDate[1]
          ).toISOString();
          if (!this.ProcessCategoryModel) {
          this.messageCreate = {
            message: "Process Category cannot be empty.",
            type: "danger",
          };
          return;
  }
        this.SchedulerReProcessModel.process_category = this.ProcessCategoryModel
        this.SchedulerReProcessModel.sub_process_category = this.SubProcessCategoryModel
        }
        try {
          api_loyalty
          .AddSchedulerReProcess(this.SchedulerReProcessModel.brand_code, this.SchedulerReProcessModel)
          .then((data) => {
            if(data.isSuccess){
              this.onResetForm();
              this.showModalCreate = false;
              this.message = {
                message: "Scheduler ReProcess created successfully.",
                type: "success",
              };
            }
          })
          .catch((e) => {
            console.log(e);
            this.showModalCreate = false;
            if (e.response && e.response.status === 401)
            {
              this.message = {
                message: "You don't have a permission",
                type: 'danger'
              }
            } else
            {
              this.message = {
                message: "Failed to create Scheduler ReProcess.",
                type: "failed",
              }
            } 
          });
        } catch (e) {
          console.log(e);
          this.message = {
            message: "Failed to add/update promo.",
            type: "danger",
          };
        }
      },
      onResetForm() {
        this.SchedulerReProcessModel = {
          id: "",
          brand_code: "PHFortune",
          start_date: new Date().toISOString(),
          end_date: new Date().toISOString(),
          reprocess: false,
          process_category: "",
          sub_process_category: "",
          is_process_complete: false,
          created_date_utc: new Date().toISOString(),
          modifyd_date_utc: new Date().toISOString(),
        };
        let momNow = this.$moment(new Date().toUTCString());
        let StartDate = momNow.format("YYYY-MM-DD");
        let EndDate = momNow.add(1, "months").format("YYYY-MM-DD");
        let momStart = this.$moment(new Date(StartDate)).format("YYYY-MM-DD");
        let momEnd = this.$moment(new Date(EndDate)).format("YYYY-MM-DD");
        this.startEndDate = [momStart, momEnd];
        this.watch_trigger_id ="0";
        this.watch_rules_id = "";
        this.watch_promo_type = ""; 
        this.isBrandCodeDisabled=false;
        this.isPromoTypeDisabled=false;
        this.RulesValue = [];
        this.rulesGet = [];
        this.unSelectedRules= [];
        this.IsMaxChancePerDayShow = false;
      },
      arrayPages() {
        var result = [];
        for (let index = 0; index < this.totalPages; index++) {
          result.push({ text: index + 1, value: index + 1 });
        }
        return result;
      },
      mappingRole() {
        let isChe = this.$store.getters.roleMappingData.some(object =>
          object.role.toLowerCase().includes('phche') &&
          object.menu.toLowerCase().includes('schedulerreprocessreport')
        );
        let isFortune = this.$store.getters.roleMappingData.some(object =>
          object.role.toLowerCase().includes('phft') ||
          object.role.toLowerCase().includes('fortune') &&
          object.menu.toLowerCase().includes('schedulerreprocessreport')
        );
        let isAdministrator = this.$store.getters.isLoginUserAdmin;
        this.brandCodeOption = [];
        if (isAdministrator || isChe)
        {
          this.brandCodeOption.push({ text: "Chesterfield", value: "PHChe" });
          this.BrandCodeModel = this.ChartBrandCodeModel = "PHChe";
          this.watch_brand_code = "PHChe";
        }

        if (isAdministrator || isFortune)
        {
          this.brandCodeOption.push({ text: "Fortune", value: "PHFortune" });
          this.BrandCodeModel = this.ChartBrandCodeModel = "PHFortune";
          this.watch_brand_code = "PHFortune";
        }
      },
      onResetFilter() {
        this.filter = {
          brand_code: this.BrandCodeModel,
        };
        
        this.onLoadData();
        this.ValueFilterModel = "";
        this.PropertyFilterModel = "";
        this.ConditionFilterModel = "is";
      },
      onSearchFilter() {
        this.filter = {
          brand_code: this.BrandCodeModel,
        };
        switch (this.PropertyFilterModel) {
          case "is_process_complete":
            this.filter.is_process_complete = this.ValueFilterModel;
            break;
          default:
            break;
        }
        this.onLoadData();
      },
      onCreateSchedulerReProcess() {
        this.showModalCreate = true;
        this.titlePopup = "Create";
        this.isBrandCodeDisabled = false;
        this.isProcessCategoryDisabled = false;
        this.isSubProcessCategoryDisabled = false;
        this.isReProcessDisabled = false;
        this.isEdit = false;
        this.onResetForm();
      },
      async onSearchExport() {
        this.onSearchFilter();
        NProgress.start();
        try {
          let response = await API.graphql({
            query: queries.exportEmsSchedulerReProcess,
            variables: {
              filter: this.filter,
              filename: "SchedulerReProcess",
            },
          });
          var presign = response.data.exportEmsSchedulerReProcess;
  
          let date_ob = new Date();
          let date = ("0" + date_ob.getDate()).slice(-2);
          let month = ("0" + (date_ob.getMonth() + 1)).slice(-2);
          let year = date_ob.getFullYear();
          let minutes = date_ob.getMinutes();
          let second = date_ob.getSeconds();
          var filename= `SchedulerReProcess_${year}-${month}-${date}-${minutes}${second}.csv`;
          
          axios
          .get(presign, { responseType: 'arraybuffer' })
          .then((response) => {
            const a = document.createElement("a");
            const blob = new Blob([response.data], { type: response.headers["content-type"] });
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = filename;
            a.click();
            console.log('end download');
          })
  
          NProgress.done();
          //document.location.href = presign;
        } catch (error) {
          console.log(error);
          NProgress.done();
        }
      },
      async onLoadData(selectedPage) {
        try {
          NProgress.start();
          this.filter.brand_code = this.BrandCodeModel;
          this.currentPage = selectedPage ? selectedPage : 1;
          let response = await API.graphql({
            query: queries.listEmsSchedulerReProcessPagination,
            variables: {
              pageSize: this.itemPerPage,
              pageNumber: this.currentPage,
              filter: this.filter,
            },
          });
          this.rows =
            response.data.listEmsSchedulerReProcessPagination.items;
          this.totalPages =
            response.data.listEmsSchedulerReProcessPagination.totalPages;
          this.totalItems =
            response.data.listEmsSchedulerReProcessPagination.totalItems;
          this.allTransaction = this.rows;
          NProgress.done();
        } catch (error) {
          console.log(error);
          NProgress.done();
        }
      },
      onSelectAllRow(payload) {
        this.selectedItems = payload.selected_items;
      },
      onSelectRow(payload) {
        this.showActionEdit = true;
        this.showActionDelete = true;
        this.selectedItems = payload.selected_items;
        console.log(this.selectedItems);
        if (
          payload.selected_items.length > 1 ||
          payload.selected_items.length == 0
        ) {
          this.showActionEdit = false;
        }
      },
      onEditRow() {
        this.SchedulerReProcessModel = this.allTransaction.filter(
          (x) => x.id === this.selectedItems[0].id
        )[0];
        this.showModalDetails = true;
        this.titlePopup = "Details";
      },
      disableUnblockUserButton(data){
        if(data.is_block == false){
          return true;
        }
        return false;
      },
    },
    components: {
      VueBootstrap4Table,
      ModelListSelect,
    },
    watch: {
      PropertyFilterModel: function (val) {
        if (val == "header" || val == "detail") {
          this.ConditionFilterModel = "contains";
        } else {
          this.ConditionFilterModel = "is";
        }
        console.log(val);
      },
      itemPerPage: function () {
        this.config.per_page = this.itemPerPage;
        this.onLoadData();
      },
      currentPage: function () {
        this.onLoadData(this.currentPage);
      },
      ProcessCategoryModel(newVal) {
      if (newVal !== 'CCDashboard') {
        this.SubProcessCategoryModel = '';
        }
      },
    },
    computed: {
      disableButtonSubmit: function () {
        let isDisabled = false;
        return isDisabled;
      },
    }
  };
  </script>
  <style></style>